module.exports = __webpack_public_path__ + "public/images/health.ac2b40bbda3a1c34ca7a44e756b39729.png";